import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { appLogger, LoggerProvider } from './logger/LoggerContext'
import { EventTrackerProvider } from './providers/event-tracker-provider'

// Make sure the DOM is fully loaded before mounting the React app
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root')

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement)

    root.render(
      <React.StrictMode>
        <LoggerProvider>
          <EventTrackerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </EventTrackerProvider>
        </LoggerProvider>
      </React.StrictMode>,
    )
  } else {
    appLogger.error('Root element not found')
  }
})
